"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collapsible = void 0;

var react_1 = __importStar(require("react"));

var Collapsible = function Collapsible(props) {
  var children = props.children,
      expanded = props.expanded,
      rest = __rest(props, ["children", "expanded"]);

  var ref = react_1.useRef();
  useCollapsible(ref, expanded || false);
  return react_1.default.createElement("div", __assign({
    ref: ref
  }, rest), children);
};

exports.Collapsible = Collapsible;

function useCollapsible(maskRef, expanded) {
  var firstUpdate = react_1.useRef(true);
  react_1.useEffect(function () {
    var maskElem = maskRef === null || maskRef === void 0 ? void 0 : maskRef.current;

    if (!maskElem) {
      return;
    }

    if (firstUpdate.current) {
      maskElem.style.height = expanded ? 'auto' : '0px';
      firstUpdate.current = false;
      return;
    }

    var iniHeight = expanded ? 0 : maskElem.scrollHeight;
    var endHeight = expanded ? maskElem.scrollHeight : 0;
    maskElem.ontransitionend = undefined;
    maskElem.style.height = 'auto';
    maskElem.style.height = iniHeight + 'px'; // only animates if there is a difference ( display none will return always 0)

    if (iniHeight !== endHeight) {
      // some browsers require a bigger delay to allow transaction animation to occur
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (expanded) {
              maskElem.ontransitionend = function (e) {
                if (e.propertyName === 'height') {
                  maskElem.style.height = 'auto';
                }
              };
            }

            maskElem.style.height = endHeight + 'px';
          });
        });
      });
    } else {
      maskElem.style.height = expanded ? 'auto' : '0px';
    }

    return function () {
      maskElem.ontransitionend = undefined;
    };
  }, [expanded, maskRef, firstUpdate]);
}

exports.default = useCollapsible;